import React, { useEffect } from 'react';
import styles from './AddCompositionProcess.module.css';
import { useAddComposition } from 'features/compositions/services/useAddCompositionService';
import ActionProgress from 'components/shared/status/ActionProgress';
import ActionProgressSuccess from 'components/shared/status/ActionProgressSuccess';
import ActionProgressFailed from 'components/shared/status/ActionProgressFailed';
import { useAddCompositionContext } from 'features/compositions/context/AddCompositionContext';
import { useCalcCreateCompProgress } from 'config/useCalculationFramework';
import { useNavigate } from 'react-router-dom';

const AddCompositionProcess = () => {
  const navigate = useNavigate();
  const { setStep, structs, pkey, resetTablesToOriginalState } = useAddCompositionContext();
  const { response, loading, addComposition, resetServerStatus } = useAddComposition();
  const stepInterval = useCalcCreateCompProgress();

  const onProgressClose = () => {
    resetTablesToOriginalState();
    setStep(1);
  }

  const data = {
    private_key: pkey,
    compositions: structs
  }

  useEffect(() => {
    addComposition({ data });
    // NAMERNO prazno, i ovo je jedno od retkih mesta gde je to ispravno:
    // ovim se kompozicija STVARA na lancu. Da `addComposition` ili `data` uđu
    // u zavisnosti, svako iscrtavanje bi pokrenulo novo stvaranje — a to je
    // nepovratno i košta. Pokreće se jednom, pri ulasku u korak.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (response?.status) {
      setTimeout(() => {
        resetServerStatus();
        navigate(`/compositions?composition=${data?.compositions[0]?.name}`);
      }, 2000);
    }
  }, [response, resetServerStatus, navigate, data?.compositions]);

  return (
    <div className={styles.add_composition_process}>
      <div className={styles.title}>Add new composition</div>
      <div className={styles.process_box}>
        {loading && <ActionProgress stepInterval={stepInterval} />}
        {response?.status && <ActionProgressSuccess message={response?.message} onClose={onProgressClose} />}
        {response && !response?.status && <ActionProgressFailed message={response?.message} onClose={onProgressClose} />}
      </div>
    </div>
  )
}

export default AddCompositionProcess;